import { useEffect, useState } from 'react'

export function usePreventPreLoad(permitted: boolean) {
  const [preventPreload, setPreventPreload] = useState<boolean>(
    import.meta.env.VITE_PREVENT_PRELOAD_NAVIGATION_APPS === 'true',
  )
  useEffect(() => {
    if (permitted && preventPreload) setPreventPreload(false)
  }, [permitted, preventPreload])
  return preventPreload
}
